import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button, Result, Spin } from "antd";
import api from "../../../utils/api";

export const verifyPayment = async (ref: string) => {
  return await api.get(
    `/Payment/PaymentDetail1?ref=${ref}`
  );
};
const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState<string | null>(null);
  const [reference, setReference] = useState<string | null>(null);

 useEffect(() => {
  const ref = searchParams.get("ref");

  if (!ref) {
    setStatus("failed");
    setLoading(false);
    return;
  }

  verifyPayment(ref)
    .then((res) => {
      console.log("VERIFY RESPONSE:", res.data);

      const apiStatus = res.data?.status;

      setStatus(apiStatus);
    })
    .catch((err) => {
      console.error("VERIFY ERROR:", err);
      setStatus("failed");
    })
    .finally(() => {
      setLoading(false);
    });
}, [searchParams]);

  // OPTIONAL: verify payment with backend here
  // useEffect(() => {
  //   if (reference) {
  //     verifyPayment(reference);
  //   }
  // }, [reference]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <Spin size="large" />
        <p>Verifying payment...</p>
      </div>
    );
  }

  const isSuccess =
    status?.toLowerCase() === "successful" ||
    status?.toLowerCase() === "success";

  return (
    <div style={{ maxWidth: "600px", margin: "80px auto", textAlign: "center" }}>
      <Result
        status={isSuccess ? "success" : "error"}
        title={
          isSuccess ? "Payment Successful 🎉" : "Payment Failed ❌"
        }
        subTitle={
          <>
            <p>Reference: {reference}</p>
            <p>Status: {status}</p>
          </>
        }
        extra={[
          <Button
            type="primary"
            key="dashboard"
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </Button>,
          !isSuccess && (
            <Button key="retry" onClick={() => navigate("/payment")}>
              Try Again
            </Button>
          ),
        ]}
      />
    </div>
  );
};

export default PaymentStatus;